import { Injectable } from '@angular/core';
import { PriceRulesService } from '../_services/settings/price-rules.service';
import { PriceRuleModel } from '../_models/price-rule.model';

@Injectable()
export class PriceRules {
  priceRules: PriceRuleModel[];
  loaded: boolean = false;
  loadRequested: boolean = false;
  callBacks: Function[] = [];

  constructor(private priceRulesService: PriceRulesService) { }

  getAll(callBack: Function = null) {
    if (!this.loaded)
      this.reload(callBack);
    else if (callBack)
      callBack(this.priceRules);
    return this.priceRules;
  }

  reload(callBack: Function = null) {
    if (callBack)
      this.callBacks.push(callBack);
    if (!this.loadRequested) {
      this.loadRequested = true;
      this.priceRulesService.getAll().subscribe((result) => {
        this.priceRules = result;
        this.loaded = true;
        for (let calback of this.callBacks) {
          calback(result);
          this.callBacks = this.callBacks.filter(cb => cb != calback);
        }
        this.loadRequested = false;
      });
    }
  }
}